import config from '@/config';
import { requests } from '.';
const whatsappUrl = config.WHATSAPP_SERVICE_URL;
export const WhatsappServices = {
    getWhatsAppPhoneNumbersForLocationId: (locationId) => requests(whatsappUrl).get(`/${locationId}/phone-numbers`),
    getLocationSubscriptions: (locationId) => requests(whatsappUrl).get(`/${locationId}/reselling/subscription`),
};
